import React from 'react'
import { Linking, Pressable, Text, View } from 'react-native'

import { useQuoteData } from '@flows-ui/services/QuoteDataContext'
import { useTranslation } from '@flows-ui/utils/i18n'
import type { ProductDocument } from '@flows/index'
import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import Spacer from '@ui-kit/components/layoutComponents/Spacer'
import { h3, h4 } from '@ui-kit/core/typography'

import { quoteSectionRow } from './sectionRowStyles'

const styles = quoteSectionRow()

type Props = {
  documents: ProductDocument[]
}

export const DocumentsSection = (props: Props) => {
  const { t } = useTranslation()
  const { trackEvent } = useQuoteData()

  if (props.documents.length === 0) {
    return null
  }

  return (
    <View className={styles.container()}>
      <Text className={h3()}>{t('sharedFlows_common:steps.quote.yourDocuments.title')}</Text>
      <Spacer size="small" />
      {props.documents.map((doc, index) => {
        const itemKey = `${doc.abstractProduct._ref}-document-${index}`
        return (
          <React.Fragment key={itemKey}>
            <Pressable
              className={styles.row()}
              onPress={() => {
                trackEvent('ListItemClicked', {
                  id: itemKey,
                  label: doc.title,
                  name: doc.link,
                })
                void Linking.openURL(doc.link)
              }}
            >
              <View className={styles.left()}>
                <PhosphorIcon name="FilePdf" size={24} />
                <Text className={h4()}>{doc.title}</Text>
              </View>
              <PhosphorIcon name="CaretRight" size={24} />
            </Pressable>
            {index + 1 !== props.documents.length && <View className={styles.divider()} />}
          </React.Fragment>
        )
      })}
    </View>
  )
}
